module.exports = __webpack_public_path__ + "img/activefindjobs.b17ff4a6.svg";